import { AssistantOrb } from "./orb";
import type { AssistantOrbProps } from "./orb/assistant-orb.types";

/**
 * Cakram seukuran orb, dipusatkan di tombol FAB; orb di-clip bulat di
 * dalamnya. Sengaja TANPA border/bayangan: orb WebGL digambar di kanvas
 * overlay terpisah, jadi garis di cakram tampak "bocor" bila orb sedikit
 * bergeser darinya. pointer-events none supaya klik tetap ke tombol.
 */
export function AssistantFabOrb(props: AssistantOrbProps) {
	const { size } = props;
	return (
		<span
			aria-hidden
			data-assistant-fab-orb
			style={{
				position: "absolute",
				top: "50%",
				left: "50%",
				width: size,
				height: size,
				transform: "translate(-50%, -50%)",
				borderRadius: "50%",
				overflow: "hidden",
				display: "grid",
				placeItems: "center",
				pointerEvents: "none",
			}}
		>
			<AssistantOrb {...props} />
		</span>
	);
}
